import addInspection from '../assets/images/add-inspection.svg';
import communities from '../assets/images/communities.svg';
import companies from '../assets/images/companies.svg';
import inspection from '../assets/images/inspection.svg';
import properties from '../assets/images/properties.svg';
import usersManagement from '../assets/images/users-management.svg';

import { Paths, Roles } from 'enums';

export const MENU_ROUTES = [
  {
    path: Paths.COMPANIES,
    name: 'Companies',
    icon: companies,
    visibleFor: [Roles.SUPER_ADMIN],
  },
  {
    path: Paths.USERS_MANAGEMENT,
    name: 'Users Management',
    icon: usersManagement,
    visibleFor: [Roles.COMPANY_ADMIN, Roles.LOCAL_ADMIN, Roles.SUPER_ADMIN],
  },
  {
    path: Paths.COMMUNITIES,
    name: 'Communities',
    icon: communities,
    visibleFor: [
      Roles.COMPANY_ADMIN,
      Roles.INSPECTOR,
      Roles.MANAGER,
      Roles.COMMUNITY_CUSTOMER,
      Roles.LOCAL_ADMIN,
    ],
  },
  {
    path: Paths.PROPERTIES,
    name: 'Properties',
    icon: properties,
    visibleFor: [Roles.COMPANY_ADMIN, Roles.LOCAL_ADMIN, Roles.PROPERTY_CUSTOMER],
  },
  {
    path: Paths.INSPECTIONS,
    name: 'Inspections',
    icon: inspection,
    visibleFor: [
      Roles.COMPANY_ADMIN,
      Roles.MANAGER,
      Roles.COMMUNITY_CUSTOMER,
      Roles.PROPERTY_CUSTOMER,
      Roles.LOCAL_ADMIN,
    ],
  },
  {
    path: Paths.ADD_INSPECTION,
    name: 'Add Inspection',
    icon: addInspection,
    visibleFor: [Roles.INSPECTOR, Roles.COMPANY_ADMIN, Roles.LOCAL_ADMIN, Roles.MANAGER],
  },
];
